// extracted by mini-css-extract-plugin
module.exports = {"root":"az_F6b","icon":"az_G6b"};